export const appHead = {"meta":[{"name":"title","content":"ETHPrague Conference May 27-29"},{"name":"description","content":"ETHPragueConf unites builders, thinkers, and visionaries to reaffirm blockchain's foundational ideals: decentralization, trustless collaboration, and open-access innovation."},{"name":"keywords","content":"ethereum, prague, blockchain, web3, crypto, conference, hackathon"},{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"robots","content":"index, follow"},{"name":"author","content":"ETHPrague Team"},{"property":"og:title","content":"ETHPrague Conference May 27-29"},{"property":"og:description","content":"ETHPragueConf unites builders, thinkers, and visionaries to reaffirm blockchain's foundational ideals: decentralization, trustless collaboration, and open-access innovation."},{"property":"og:image","content":"https://ethprague.com/ETHPrague_soc_share-2025.png"},{"property":"og:image:type","content":"image/png"},{"property":"og:image:secure_url","content":"https://ethprague.com/ETHPrague_soc_share-2025.png"},{"property":"og:url","content":"https://ethprague.com/"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"ETHPrague"},{"property":"og:locale","content":"en_US"},{"property":"og:image:width","content":"1920"},{"property":"og:image:height","content":"1080"},{"property":"og:image:alt","content":"ETHPrague 2025"},{"property":"event:start_time","content":"2025-05-27T09:00:00Z"},{"property":"event:end_time","content":"2025-05-29T18:00:00Z"},{"name":"twitter:title","content":"ETHPrague Conference May 27-29"},{"name":"twitter:description","content":"ETHPragueConf unites builders, thinkers, and visionaries to reaffirm blockchain's foundational ideals: decentralization, trustless collaboration, and open-access innovation."},{"name":"twitter:image","content":"https://ethprague.com/ETHPrague_soc_share-2025.png"},{"name":"twitter:site","content":"@EthPrague"},{"name":"twitter:creator","content":"@EthPrague"},{"name":"twitter:card","content":"summary_large_image"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"canonical","href":"https://ethprague.com/"}],"style":[],"script":[{"src":"https://www.googletagmanager.com/gtag/js?id=G-P6BDXC4LL7","async":true},{"innerHTML":"\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag('js', new Date());\n            gtag('config', 'G-P6BDXC4LL7');\n          "}],"noscript":[],"title":"ETHPrague Conference May 27-29"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true